<script>
export default {
  name: "upload",
}
</script>

<template>
  <svg data-v-78328012="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 21 21"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 15.5h-4c-1.152-.419-2-1.703-2-3a3 3 0 0 1 3.1-2.998 5.002 5.002 0 1 1 9.702 2.397A2 2 0 1 1 16.5 15.5h-4M8.5 17.5l2 2 2-2M10.5 9.5v10"></path></g></svg>
</template>
